import React from 'react';
import { Table, Badge, Text, Group, ActionIcon, Menu, Avatar, rem } from '@mantine/core';
import { IconDots, IconExternalLink, IconTrash } from '@tabler/icons-react';
import { Job } from '../../api/jobs';
import { useNavigate } from 'react-router-dom';

interface RecentActivityTableProps {
    jobs: Job[];
}

const RecentActivityTable: React.FC<RecentActivityTableProps> = ({ jobs }) => {
    const navigate = useNavigate();

    const getStatusColor = (status: Job['status']) => {
        switch (status) {
            case 'active': return 'blue';
            case 'applied': return 'green';
            case 'rejected': return 'red';
            case 'archived': return 'gray';
            default: return 'gray';
        }
    };

    const rows = jobs.map((job) => (
        <Table.Tr key={job.id} style={{ cursor: 'pointer' }} onClick={() => navigate(`/jobs/${job.id}`)}>
            <Table.Td>
                <Group gap="sm">
                    <Avatar color="blue" radius="xl">
                        {job.company.substring(0, 1).toUpperCase()}
                    </Avatar>
                    <div>
                        <Text fz="sm" fw={500}>
                            {job.title}
                        </Text>
                        <Text fz="xs" c="dimmed">
                            {job.company}
                        </Text>
                    </div>
                </Group>
            </Table.Td>
            <Table.Td>
                <Text fz="sm">{new Date(job.created_at).toLocaleDateString()}</Text>
            </Table.Td>
            <Table.Td>
                <Badge color={getStatusColor(job.status)} variant="light">
                    {job.status}
                </Badge>
            </Table.Td>
            <Table.Td onClick={(e) => e.stopPropagation()}>
                <Group gap={0} justify="flex-end">
                    <ActionIcon component="a" href={job.url} target="_blank" variant="subtle" color="gray">
                        <IconExternalLink style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                    </ActionIcon>
                    <Menu transitionProps={{ transition: 'pop' }} withArrow position="bottom-end" withinPortal>
                        <Menu.Target>
                            <ActionIcon variant="subtle" color="gray">
                                <IconDots style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
                            </ActionIcon>
                        </Menu.Target>
                        <Menu.Dropdown>
                            <Menu.Item
                                leftSection={<IconTrash style={{ width: rem(16), height: rem(16) }} stroke={1.5} />}
                                color="red"
                            >
                                Delete
                            </Menu.Item>
                        </Menu.Dropdown>
                    </Menu>
                </Group>
            </Table.Td>
        </Table.Tr>
    ));

    return (
        <Table verticalSpacing="sm" highlightOnHover>
            <Table.Thead>
                <Table.Tr>
                    <Table.Th>Role & Company</Table.Th>
                    <Table.Th>Date Added</Table.Th>
                    <Table.Th>Status</Table.Th>
                    <Table.Th />
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    );
};

export default RecentActivityTable;
